import React, { Component } from "react";
import moment from "moment";
import $ from "jquery";

import "bootstrap/dist/js/bootstrap.min.js";
import "bootstrap/dist/css/bootstrap.min.css";
import "eonasdan-bootstrap-datetimepicker/build/js/bootstrap-datetimepicker.min.js";
import "eonasdan-bootstrap-datetimepicker/build/css/bootstrap-datetimepicker.min.css";

export default class ChatBoxMessageSumbitDialysisPregnant extends Component {
  state = {
    date: moment().format("YYYY-MM-DD HH:mm"),
    before_breakfast : '',
    before_lunch : '',
    before_dinner : '',
    after_breakfast_1 : '',
    after_lunch_1 : '',
    after_dinner_1 : '',
    after_breakfast_2 : '',
    after_lunch_2 : '',
    after_dinner_2 : '',
  }

  componentDidMount() {

    this.datepickerRender()
  }

  datepickerRender = () => {
    var _this = this;
    $("#d-dialysis-pregnant-datepicker")
    .on("dp.hide", function (e) {
      
      _this.setState({
        date : e.date.format("YYYY-MM-DD HH:mm")
      });
    })
    .datetimepicker({
      format: "DD/MM/YYYY HH:mm",
      defaultDate: moment(),
      keepOpen: true
    });
  }

  

  render() {
    return <div>
      <div>
      <div className="uk-text-small">วันที่</div>
      <div class='input-group date uk-margin-small-top uk-width-medium' id='d-dialysis-pregnant-datepicker'>
          <input type='text' class="form-control" />
          <span class="input-group-addon">
          <span class="glyphicon glyphicon-calendar"></span>
          </span>
        </div>
      </div>
      <div className="uk-text-small uk-margin-small-top">ตารางน้ำตาลเบาหวานตั้งครรภ์</div>
      <div className="uk-overflow-auto uk-margin-small-top">
        <table className="uk-table uk-table-small uk-table-divider d-table-diabates-data">
          <thead>
            <tr>
              <th colSpan={3}>ก่อนรับประทานอาหาร</th>
              <th colSpan={3}>หลังรับประทานอาหาร 1 ชั่วโมง</th>
              <th colSpan={3}>หลังรับประทานอาหาร 2 ชั่วโมง</th>
            </tr>
            <tr>
              <th>เช้า</th>
              <th>เที่ยง</th>
              <th>เย็น</th>
              <th>เช้า</th>
              <th>เที่ยง</th>
              <th>เย็น</th>
              <th>เช้า</th>
              <th>เที่ยง</th>
              <th>เย็น</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><input type="text" className="uk-input uk-text-center" value={this.state.before_breakfast} onChange={(e)=>this.setState({before_breakfast: e.target.value})} /></td>
              <td><input type="text" className="uk-input uk-text-center" value={this.state.before_lunch} onChange={(e)=>this.setState({before_lunch: e.target.value})} /></td>
              <td><input type="text" className="uk-input uk-text-center" value={this.state.before_dinner} onChange={(e)=>this.setState({before_dinner: e.target.value})} /></td>
              <td><input type="text" className="uk-input uk-text-center" value={this.state.after_breakfast_1} onChange={(e)=>this.setState({after_breakfast_1: e.target.value})} /></td>
              <td><input type="text" className="uk-input uk-text-center" value={this.state.after_lunch_1} onChange={(e)=>this.setState({after_lunch_1: e.target.value})} /></td>
              <td><input type="text" className="uk-input uk-text-center" value={this.state.after_dinner_1} onChange={(e)=>this.setState({after_dinner_1: e.target.value})} /></td>
              <td><input type="text" className="uk-input uk-text-center" value={this.state.after_breakfast_2} onChange={(e)=>this.setState({after_breakfast_2: e.target.value})} /></td>
              <td><input type="text" className="uk-input uk-text-center" value={this.state.after_lunch_2} onChange={(e)=>this.setState({after_lunch_2: e.target.value})} /></td>
              <td><input type="text" className="uk-input uk-text-center" value={this.state.after_dinner_2} onChange={(e)=>this.setState({after_dinner_2: e.target.value})} /></td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="uk-text-right uk-margin-top">
      {
        this.props.messageListSending === true ?
        <div><span uk-spinner=""></span></div>
          :
        <button type="button" className="uk-button uk-button-primary" onClick={async ()=>{
          await this.props.callback(this.state);

          this.setState({
            before_breakfast : '',
            before_lunch : '',
            before_dinner : '',
            after_breakfast_1 : '',
            after_lunch_1 : '',
            after_dinner_1 : '',
            after_breakfast_2 : '',
            after_lunch_2 : '',
            after_dinner_2 : '',
          })
        }}>
          บันทึก
        </button>
      }
      </div>
    </div>
  }
}